

import React from 'react';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import MissingPhoneForm from './MissingPhoneForm';
import returnHeader from "../Register/RegisterHeaders";
import AppVars from '../../../../AppVars.js';


const INPUT_VALIDATION = {
    "PHONE" : "^(?!0)[0-9]{10}$"
}

const appVars = AppVars.getInstance();

class MissingPhoneView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
    

        }
    }

    render (){
            return(
                <div>
                <div className = "justify-content-center line-box">
                    <Row className = "">
                    <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                    </Row>
                    <div
                        id = "missingFieldsSubmissionError"
                        data-testid = "missingFieldsSubmissionError"  
                        className = {`${this.props.isResponseValid === false ? "error-modal" : "none"}`} 
                        role = "alert"
                        aria-hidden = {`${this.props.isResponseValid === false ? "false" : "true"}`}>
                    <div className = "error-modal-text">
                    The service is down. Please try again shortly.
                    </div>
                    <span onClick={this.props.hideModal} className = "modal-close">&times;</span>
                    
                    </div>
                    <div>
                        {returnHeader("FINISH-SOCIAL", this.props.provider, this.props.style)}
                    </div>

                    <Form id = "missingPhoneFieldsForm" noValidate validated = {this.props.isPhoneValid} onSubmit={this.props.handleMissingFieldsFormSubmit}>
                    {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
                    <MissingPhoneForm 
                        phone={this.props.telephoneNumber} 
                        handlePhoneChange={this.props.handlePhoneChange} 
                        isPhoneValid={this.props.isPhoneValid} 
                        isPhoneAvailable={this.props.isPhoneAvailable}
                        setFocusPhone = {this.props.setFocusPhone}
                        removeFocusPhone = {this.props.removeFocusPhone}
                        phoneFocus = {this.props.phoneFocus}
                        floatPhone = {this.props.floatPhone}
                        onBlurPhone = {this.props.onBlurPhone}
                        />
                    <div className="required required-left-grid"><span><span id="redStar">*</span>Required</span></div>
                    <div className = "button-right">
                        <Button data-testid = "createPasswordButton" bsPrefix = {`${this.props.isPhoneValid !== true ? "button-disabled__TO" : "button__TO "}`} type = "submit" >Submit</Button>
                    </div>
                    </Form>
                </div>
                </div>
            )
        }
    }


export default MissingPhoneView;